export default
{
    aboutUs: {
        headline: "We've got what you need!",
        text: "Start Bootstrap has everything you need to get your new website up and running in no time! Choose one of our open source, free to download, and easy to use themes! No strings attached!",
        bgColor: "#333",
    },
    something: {
        headline: "Let's Get In Touch!",
        text: "Ready to start your next project with us? Give us a call or send us an email and we will get back to you as soon as possible!",
        bgColor: "white",
    },

    images: {
        firstRow:[
            "https://images.pexels.com/photos/1095965/pexels-photo-1095965.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "https://images.pexels.com/photos/1867241/pexels-photo-1867241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "https://images.pexels.com/photos/734973/pexels-photo-734973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        ],
        secondRow:[
            "https://images.pexels.com/photos/235988/pexels-photo-235988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "https://images.pexels.com/photos/2274715/pexels-photo-2274715.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "https://images.pexels.com/photos/296283/pexels-photo-296283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        ]
    },

    images2: {
        0: "https://images.pexels.com/photos/734973/pexels-photo-734973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        1: "https://images.pexels.com/photos/1533720/pexels-photo-1533720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        2: "https://images.pexels.com/photos/1533720/pexels-photo-1533720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    }
};